import Vue from 'vue'
import moment from 'moment'
import 'moment/locale/zh-cn'
import { buildFile } from '@/utils/util'
import _ from 'lodash'
moment.locale('zh-cn')
Vue.filter('NumberFormat', function (value) {
  if (!value) {
    return '0'
  }
  const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
  return intPartFormat
})

Vue.filter('dayjs', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

Vue.filter('moment', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

Vue.filter('valInDict', function (key = '', dict = [], keyName = 'id', valueName = 'name', defaultValue = '') {
  if (key === '' || !_.isArray(dict) || dict.length === 0) {
    return key || defaultValue
  }
  for (var i = 0; i < dict.length; i++) {
    if (dict[i][keyName] === key) {
      return dict[i][valueName]
    }
  }
  return defaultValue
})

Vue.filter('nullval', function (value = '', defaultValue = '') {
  if (value === '' || !value || value === 0) return defaultValue
  else return value
})

Vue.filter('judge', function (value = '') {
  if (value === 'YES') return '是'
  if (value === 'NO') return '否'
})

// Vue.filter('buildFile', function (id = '', w = '', h = '', watermark = 'NO') {
//   return buildFile(id, w, h, watermark)
// })

Vue.filter('buildFile', function (id = '', w = '', h = '', watermark = 'NO', url = '/avatar.png') {
  let res = ''
  if (id !== '') {
    res = buildFile(id, w, h, watermark)
  } else {
    res = url
  }
  return res
})

Vue.filter('statusTagFilter', function (val) {
  let color = ''
  switch (val) {
    case 'NORMAL':
      color = 'red'
      break
    case 'PAY':
      color = 'blue'
      break
    case 'PRINT':
      color = 'purple'
      break
    case 'DELIVERED':
      color = 'orange'
      break
    case 'RECEIVED':
      color = 'cyan'
      break
    case 'DONE':
      color = 'green'
      break
    case 'CANCEL':
      color = '#ccc'
      break
    default:
      color = ''
  }
  return color
})

Vue.filter('statusTagFilter2', function (val) {
  let color = ''
  switch (val) {
    case 'NORMAL':
      color = 'cyan'
      break
    case 'PRINTED':
      color = 'blue'
      break
    case 'REGISTERED':
      color = 'purple'
      break
    default:
      color = ''
  }
  return color
})
